import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'lib-app-footer',
  imports: [
    MatIcon
  ],
  templateUrl: './app-footer.component.html',
  styleUrl: './app-footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppFooterComponent {
  public readonly currentYear = new Date().getFullYear();
}
